import { render, staticRenderFns } from "./RegionSwitcherModal.vue?vue&type=template&id=687b0f29&scoped=true&"
import script from "./RegionSwitcherModal.vue?vue&type=script&lang=ts&"
export * from "./RegionSwitcherModal.vue?vue&type=script&lang=ts&"
import style0 from "./RegionSwitcherModal.vue?vue&type=style&index=0&id=687b0f29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687b0f29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('687b0f29')) {
      api.createRecord('687b0f29', component.options)
    } else {
      api.reload('687b0f29', component.options)
    }
    module.hot.accept("./RegionSwitcherModal.vue?vue&type=template&id=687b0f29&scoped=true&", function () {
      api.rerender('687b0f29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/component/footer/RegionSwitcherModal.vue"
export default component.exports